import { isNullish } from './nullish-check';

const REDIRECT_TO_KEY = 'redirect_to_v2';

export function setPulseUIRedirectTo(url?: string) {
  if (isNullish(url)) {
    localStorage.removeItem(REDIRECT_TO_KEY);
  } else {
    localStorage.setItem(REDIRECT_TO_KEY, url);
  }
}

export function getPulseUIRedirectTo() {
  const value = localStorage.getItem(REDIRECT_TO_KEY);
  return !!value ? value : undefined;
}
